import React, { useEffect, useState } from 'react';

const getCookie = (name) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(name + "=") === 0) {
      return c.substring(name.length + 1, c.length);
    }
  }
  return "";
};

const setCookie = (name, value, days) => {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!getCookie("cookies_accepted")) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie("cookies_accepted", "true", 365);
    setShowBanner(false);
  };

  const handleDecline = () => {
    setShowBanner(false);
    // Redirect the user to the previous page if they decline the cookies
    if (document.referrer) {
        window.location.href = document.referrer;  // Go back to the previous page
    } else {
        window.location.href = "https://example.com";  // Fallback URL if there's no referrer
    }
  };

  if (!showBanner) return null;

  return (
    <div style={styles.banner}>
      <h1>Permitir Cookies</h1>
      <div style={styles.message}>
        <p>
          Nosso site usa cookies. Armazenamos dados temporariamente para melhorar a sua experiencia. Ao continuar, assumimos a sua autorização conforme nossa {" "}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={styles.link}>
            Política de cookies
          </a>
          .
        </p>
        <button onClick={handleAccept} style={styles.button}>Aceitar</button>
        <button onClick={handleDecline} style={styles.buttonDecline}>Declinar</button>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: 'fixed',
    bottom: 10,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#333',
    color: 'white',
    padding: '10px',
    textAlign: 'center',
    fontSize: '14px',
    maxWidth: '400px',  
    width: '100%',
    borderRadius: '8px',
    zIndex: 1000,
    backgroundColor: '#3d59a3',
  },
  message: {
    maxWidth: '1200px',
    margin: '0 auto',
    marginBottom: '10px',
  },
  button: {
    margin: '0 10px',
    padding: '10px 50px',
    borderRadius: '20px',
    backgroundColor: '#f1f1f1',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#da8431',
  },

  buttonDecline: {
    margin: '0 10px',
    padding: '10px 50px',
    borderRadius: '20px',
    backgroundColor: '#f1f1f1',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    color:'grey'
  },

  link: {
    color: '#da8431'
  }
  
};

export default CookieBanner;
